const images = {
  profileLogo: require('./profile.png'),
  journeyImage: require('./journey.png'),
  booklogo: require('./Group.png'),
  logouticon:require('./logout.png'),
  upIocn:require('./chevron-up.png'),
  downIcon:require('./chevron-down.png'),
  backIcon:require('./back.png'),
  askIcon:require('./ask.png'),
  forwardIcon:require('./rightArrow.png'),
  crossIcon:require('./cross.png'),
  blackBackground:require('./blackB.jpg'),
  info:require('./info.png'),
  pencil:require('./pencil.png'),
  audioIcon:require('./audio.png'),
  playIcon:require('./play.png'),
  chatIcon:require('./chat.png'),
  yetiBored:require('../jsons/yetiBored.json'),
  pauseIcon:require('./pauseIcon.png'),
  emptyBar:require('./bar.png'),
  checkIcon:require('./check.png'),
  happy:require('./happy.png'),
  sad:require('./sad.png'),
  excited:require('./excited.png'),
  curious:require('./curious.png'),
  tired:require('./tired.png'),
  bored:require('./bored.png'),
  yeti:require('./yeti.png'),
  resources:require('./resources.png'),
  worksheet:require('./worksheet.png'),
  closeIcon:require('./close.png'),
  pdfDownload:require('./pdf-download.png'),

}
export default images